/** Final CTA: copy deck §8. Clean brand-tinted band closing the page before
 * the footer (PhishFence restraint: no dark band, no grid motif). */
import { StartFreeButton, AnchorButton } from './Section.js';

export function FinalCta() {
  return (
    <section className="border-t border-slate-200 bg-brand-50 px-4 py-20 sm:px-6 sm:py-24">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-slate-900 sm:text-4xl">
          Send cold email like you intend to keep your domain.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-slate-600">
          Connect your Google inbox, warm it up, and run your first campaign with
          the guardrails already on. Free to start, no credit card.
        </p>
        <div className="mt-9 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <StartFreeButton
            className="w-full sm:w-auto"
            ringOffsetClass="focus-visible:ring-offset-brand-50"
          />
          <AnchorButton
            href="#deliverability"
            className="w-full sm:w-auto"
            ringOffsetClass="focus-visible:ring-offset-brand-50"
          >
            See how deliverability works
          </AnchorButton>
        </div>
      </div>
    </section>
  );
}
